import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getChildrenFileList = (params, urlParams) => {
  return axios.request({
    url: '/ops/systemlog/getchildrenfilelist' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const removeFile = (params, urlParams) => {
  return axios.request({
    url: '/ops/systemlog/removefile' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getFileContent = (params, urlParams) => {
  return axios.request({
    url: '/ops/systemlog/getfilecontent' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

